import { casesStatusUpdateApi, getAllSubscribedProfessionals, raiseNotificationApi, revertApprovalApi } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useState } from 'react'
import { getCaseType } from 'Utils';
import PreApproved from './PreApproved';
import PreApprovedProfessionalsList from './PreApprovedProfessionalsList';
import CloseIcon from 'Components/Icons/CloseIcon';
import PreapproveProfessionalsModal from 'Modals/PreapproveProfessionalsModal';
import { ChevronDown, User } from 'lucide-react';
import { FaMoneyBillTrendUp } from 'react-icons/fa6';
import { SquareUserRound } from 'lucide-react';
import CaseDetailsToggleTile from './CaseDetailsToggleTile';


function PreApprovedContentOnDetails({caseDetails, updateComp,
    setUpdateComp,
}) {
    const {makeApiCallFunc} = useContext(Context);
    const [toggleInfo, setToggleInfo] = useState(false);
    const [availableProfessionals, setAvailableProfessionals] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const [showPreApproveContent, setShowPreApproveContent] = useState(true);
    const revertApproval = (id) => {
        const postData = {
            caseId: caseDetails?._id,
            "userId" : id,
        }
        makeApiCallFunc(
            revertApprovalApi,
            postData,
            (data) => {
                const notificationObj = {
                    title : "Reverted Pre-approved case - " + getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber,
                    is_read : false,
                    sender: "client",
                    notificationCategory: 1,
                    caseNumber: caseDetails?.caseNumber,
                    type: "4",
                    receiver:  id,
                    additionalInfo: {
                        caseId: caseDetails?._id
                    },
                    content: "Your preapproval has been reverted by the client for the case - " + getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber + ". Find this case listed on the available cases list."
                }
                makeApiCallFunc(raiseNotificationApi, 
                    notificationObj, 
                    (data) => console.log(data),
                    (error) => console.log(error)
                    )
            //    seeAvailableProfessionals();
                setUpdateComp(prev => !prev)
            },
            (data) => {
                console.log(data)
            }
        )
    }
    const approveProfessional = (id) => {
        const postData = {
            caseId: caseDetails?._id,
            "userId" : id,
            "assistantId" : null,
            caseStatus: "approved",
            isPreApproved: true
        }
        makeApiCallFunc(
            casesStatusUpdateApi,
            postData,
            (data) => {
                // seeAvailableProfessionals();
                setUpdateComp(prev => !prev)
                const notificationObj = {
                    title : "Pre-Approved Request - " + getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber,
                    is_read : false,
                    sender: "client",
                    notificationCategory: 1,
                    caseNumber: caseDetails?.caseNumber,
                    type: "3",
                    receiver:  id,
                    additionalInfo: {
                        caseId: caseDetails?._id
                    },
                    content: "You have been pre-approved to view the case " + getCaseType(caseDetails?.caseType) + " - " + caseDetails?.caseNumber + " by the potential client. Find this case in your approved cases list. You may now proceed to check for conflicts."
                }
                makeApiCallFunc(raiseNotificationApi, 
                    notificationObj, 
                    (data) => console.log(data),
                    (error) => console.log(error)
                    )
            },
            (data) => {
                console.log(data)
            }
        )
        }
   
    const seeAvailableProfessionals = () => {
        makeApiCallFunc(
            getAllSubscribedProfessionals,
            {caseId: caseDetails._id,
            casePref: caseDetails?.caseType,
            statePref: caseDetails?.caseState
            },
            ({data}) => {
                setAvailableProfessionals(data?.available);
            },
            (error) => {
                console.log(error)
            }
        )
    }
    useEffect(() => {

        seeAvailableProfessionals();
    }, [
        updateComp
    ]);
    useEffect(() => {
        // setShowModal(true); - commented coz we dont want to show popup when client clicks on see more from a notificaion of attorney request. its confusing 

    }, [])
  return (
    <>
    {
        showModal && availableProfessionals?.length > 0 &&
        <PreapproveProfessionalsModal 
        uploadNew={showModal}
        onClose={() => setShowModal(false)}
        profList={availableProfessionals}
        caseDetails={caseDetails}
        approveProfessional={approveProfessional}
        />
    }
    {availableProfessionals?.length > 0 &&
     <div className='bg-transparent'>
       <CaseDetailsToggleTile
        toggleInfo={toggleInfo}
        setToggleInfo={setToggleInfo}
        icon = {<User size={18} />}
        title={"Approve Attorneys"}
        description={`${availableProfessionals.length} waiting`}
        />
            {toggleInfo && (
                        showPreApproveContent ?
                <div className=''>
                    <div className=''>
                        <PreApproved
                        caseDetails={caseDetails}
                        showPreApproveContent={showPreApproveContent}
                        setShowPreApproveContent={setShowPreApproveContent}
                        availableProfessionals={availableProfessionals}
                        approveProfessional={approveProfessional}
                        />
                    </div>
                </div>
                :
                <></>
            )}
            </div>
        }
</>
)}

export default PreApprovedContentOnDetails